import React from 'react';
import { LockIcon, DownloadIcon, ZapIcon } from 'lucide-react';
export function TopUrgencyBar() {
  return <div className="bg-heading text-white py-3 px-4 text-center" data-id="element-280">
      <div className="flex items-center justify-center gap-6 text-sm md:text-base flex-wrap" data-id="element-281">
        <span className="flex items-center gap-2" data-id="element-282">
          <LockIcon className="w-4 h-4" data-id="element-283" />
          Acceso inmediato
        </span>
        <span className="hidden md:inline" data-id="element-284">·</span>
        <span className="flex items-center gap-2" data-id="element-285">
          <DownloadIcon className="w-4 h-4" data-id="element-286" />
          Descarga instantánea
        </span>
        <span className="hidden md:inline" data-id="element-287">·</span>
        <span className="flex items-center gap-2" data-id="element-288">
          <ZapIcon className="w-4 h-4" data-id="element-289" />
          Precio de lanzamiento por tiempo limitado
        </span>
      </div>
    </div>;
}